// export const CLIENT_URL = "guildapi";

export const CLIENT_URL_DEV = "guildapi";

export const CLIENT_URL_LIVE = "api";

export const DEV_DOMAIN = "demobw.com/webapi";

export const LIVE_DOMAIN_API = "guildandfacet.com/webapi";
export const LIVE_DOMAIN = "guildandfacet.com/webapi";

export const API_URL = `https://${CLIENT_URL_LIVE}.${LIVE_DOMAIN_API}`;

export const METAL_COLORS_URL = `https://${CLIENT_URL_LIVE}.${LIVE_DOMAIN_API}/assets/metal_color/`;

export const SHAPES_IMG_URL = `https://${CLIENT_URL_LIVE}.${LIVE_DOMAIN_API}/assets/shape/`;

// export const METAL_COLORS_URL = `https://${CLIENT_URL}.demobw.com/webapi/assets/metal_color/`;

// export const SHAPES_IMG_URL = `https://${CLIENT_URL}.demobw.com/webapi/assets/shape/`;

export const ERR_MESSAGE = "Something went wrong, Please try again later.";

export const LOGIN_FIRST_MESSAGE = "Please Login!";

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SUBDOMAIN_REGEX = /^(?!-)(?!.*--)[A-Za-z0-9-]{1,63}(?<!-)$/;

export const DECIMAL_CHECK_REGEX = /^(\d+)?(?:\.\d{1,4})?$/;

export const METAL_TYPE_OBJ = {
  _10K: "10K",
  _14K: "14K",
  _18K: "18K",
  _W: "White",
  _P: "Platinum",
  _L: "Palladium",
  _S: "Silver",
};

export const METAL_COLOR_OBJ1 = {
  R: "Rose",
  RWR: "Rose/White/Rose",
  RYR: "Rose/Yellow/Rose",
  W: "White",
  WRW: "White/Rose/White",
  WYW: "White/Yellow/White",
  YRY: "Yellow/Rose/Yellow",
  Y: "Yellow",
  YWY: "Yellow/White/Yellow",
};

export const METAL_COLOR_OBJ = {
  R: "Rose",
  RW: "Rose/White",
  RWR: "Rose/White/Rose",
  RWRWR: "Rose/White/Rose/White/Rose",
  RYR: "Rose/Yellow/Rose",
  W: "White",
  WR: "White/Rose",
  WRW: "White/Rose/White",
  WRWRW: "White/Rose/White/Rose/White",
  WY: "White/Yellow",
  WYW: "White/Yellow/White",
  WYWYW: "White/Yellow/White/Yellow/White",
  Y: "Yellow",
  YRY: "Yellow/Rose/Yellow",
  YW: "Yellow/White",
  YWY: "Yellow/White/Yellow",
  YWYWY: "Yellow/White/Yellow/White/Yellow",
};

export const FINISH_OBJ = {
  AS: "Angle Satin",
  BF: "Bark Finish",
  CM: "Circle Matt",
  CS: "Cross Satin",
  FF: "Florentine Finish",
  HM: "Hammer",
  HP: "High Polish",
  S: "Satin",
  SB: "Sand Blast",
  SF: "Stone Finish",
};

export const THICKNESS_OBJ = {
  LW: "Light Weight 1.5MM",
  SW: "Standard Weight 1.9MM",
  PW: "Premium Weight 2.2MM",
};

export const PROFILE_OBJ = {
  BVED: "Beveled Edge",
  CTRN: "Center Round",
  DBMG: "Double Millgrain",
  DRED: "Double Round Edge",
  FDCF: "Full Dome Comfort Fit",
  FDNC: "Full Dome Non Comfort Fit",
  FLCF: "Flat Comfort Fit",
  FLED: "Flat Edge",
  FNCF: "Flat Non Comfort Fit",
  LDCF: "Low Dome Comfort Fit",
  LDNC: "Low Dome Non Comfort Fit",
  RDMG: "Round Milgrain",
  RNED: "Round Edge",
  SGPR: "Signature Profile",
};
